export default {
  feedBackTypes: (state) => {
    return state.feedBackTypes;
  },
  feedBackTypeCode: (state) => {
    return state.feedBackTypeCode;
  },

  feedBack: (state) => {
    return state.feedBack;
  },
  feedBackItem: (state) => {
    return state.feedBackItem;
  },
  feedBackCode: (state) => {
    return state.feedBackCode;
  },
  feedBackId: (state) => {
    return state.feedBackId;
  },
  feedbackAnswerId: (state) => {
    return state.feedbackAnswerId;
  },

  feedbackQuestion: (state) => {
    return state.feedbackQuestion;
  },

  feedbackAnswers: (state) => {
    return state.feedbackAnswers;
  },

  feedbackAnswer: (state) => {
    return state.feedbackAnswer;
  },

  feedbackQuestionOptions: (state) => {
    return state.feedbackQuestionOptions;
  },
  feedbackQuestionOption: (state) => {
    return state.feedbackQuestionOption;
  },

  personClubGroup: (state) => {
    return state.personClubGroup;
  },
  personClubGroupCode: (state) => {
    return state.personClubGroupCode;
  },
  personClubByMobile: (state) => {
    return state.personClubByMobile;
  },
  personClubModal: (state) => {
    return state.personClubModal;
  },

  salesChannel: (state) => {
    return state.salesChannel;
  },
  salesChannelCode: (state) => {
    return state.salesChannelCode;
  },

  introducedType: (state) => {
    return state.introducedType;
  },
  introducedTypeCode: (state) => {
    return state.introducedTypeCode;
  },

  customerTag: (state) => {
    return state.customerTag;
  },
  customerTagCode: (state) => {
    return state.customerTagCode;
  },

  occasionType: (state) => {
    return state.occasionType;
  },
  occasionTypeCode: (state) => {
    return state.occasionTypeCode;
  },

  deliveryMethods: (state) => {
    return state.deliveryMethods;
  },
  deliveryMethodCode: (state) => {
    return state.deliveryMethodCode;
  },

  paymentMethods: (state) => {
    return state.paymentMethods;
  },
  paymentMethodCode: (state) => {
    return state.paymentMethodCode;
  },

  discounts: (state) => {
    return state.discounts;
  },
  discount: (state) => {
    return state.discount;
  },
  discountCode: (state) => {
    return state.discountCode;
  },
  validateDiscountCode: (state) => {
    return state.validateDiscountCode;
  },

  personsClub: (state) => {
    return state.personsClub;
  },
  personClub: (state) => {
    return state.personClub;
  },
  personClubCode: (state) => {
    return state.personClubCode;
  },
  personSearchSuccess: (state) => {
    return state.personSearchSuccess;
  },
  personClubSearch: (state) => {
    return state.personClubSearch;
  },

  smsSetting: (state) => {
    return state.smsSetting;
  },
  smsSettingById: (state) => {
    return state.smsSettingById;
  },
  processes: (state) => {
    return state.processes;
  },
  process: (state) => {
    return state.process;
  },
  processCode: (state) => {
    return state.processCode;
  },

  scoreTransaction: (state) => {
    return state.scoreTransaction;
  },
  creditTransaction: (state) => {
    return state.creditTransaction;
  },
  validateCreditCode: (state) => {
    return state.validateCreditCode;
  },

  purchases: (state) => {
    return state.purchases;
  },
  purchase: (state) => {
    return state.purchase;
  },
  purchaseSearchByMobile: (state) => {
    return state.purchaseSearchByMobile;
  },

  personClubGrades: (state) => {
    return state.personClubGrades;
  },
  personClubGradeCode: (state) => {
    return state.personClubGradeCode;
  },

  personClubPurchase: (state) => {
    return state.personClubPurchase;
  },

  customerPurchaseReport: (state) => {
    return state.customerPurchaseReport;
  },

  scoreSummery: (state) => {
    return state.scoreSummery;
  },

  mostCustomerRegistrations: (state) => {
    return state.mostCustomerRegistrations;
  },

  requirementProfile: (state) => {
    return state.requirementProfile;
  },

  apiKeyAccess: (state) => {
    return state.apiKeyAccess;
  },

  feedbackReport: (state) => {
    return state.feedbackReport;
  },
  // feedbackDetailReport: (state) => {
  //   return state.feedbackDetailReport;
  // },
  feedbackDetailReport: (state) => {
    return state.feedbackDetailReport.map((question) => {
      const totalCount = question.answers.reduce(
        (sum, answer) => sum + answer.count,
        0,
      );
      let totalPercentage = 0;

      let feedbackDetailReport = question.answers.map((answer) => {
        let percentage = totalCount ? (answer.count / totalCount) * 100 : 0;
        percentage = parseFloat(percentage.toFixed(2));
        totalPercentage += percentage;

        return { ...answer, percentage };
      });
      if (feedbackDetailReport.length > 0) {
        let diff = 100 - totalPercentage;
        feedbackDetailReport[feedbackDetailReport.length - 1].percentage +=
          diff;
        feedbackDetailReport[feedbackDetailReport.length - 1].percentage =
          parseFloat(
            feedbackDetailReport[
              feedbackDetailReport.length - 1
            ].percentage.toFixed(2),
          );
      }

      return { ...question, answers: feedbackDetailReport };
    });
  },
  personClubFeedbackReport: (state) => {
    return state.personClubFeedbackReport;
  },
  personClubFeedbackLog: (state) => {
    return state.personClubFeedbackLog;
  },
  answerPersonClub: (state) => {
    return state.answerPersonClub;
  },
};
